/**
 * @file index.tsx
 * @deprecated Copied to app/modules/procurement/pages/vendor-ledger/index.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/vendor-ledger/index
 * @description Implements the index interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Outlet, Route, Routes } from 'react-router-dom';
import VendorLedgerPage from './vendor-ledger';
import { PageLink, PageTitle } from '../../../../_admin/layout/core';
const vendorLedgerBreadCrumbs: Array<PageLink> = [
    {
        title: 'UProcure',
        path: '/UProcure',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
];
const VendorLedgerLayoutPage = () => (
    <Routes>
        <Route element={< Outlet />}>
            <Route
                index
                element={
                    <>
                        <PageTitle breadcrumbs={vendorLedgerBreadCrumbs}>
                            Supplier Ledger
                        </PageTitle>
                        <VendorLedgerPage />
                    </>
                }
            />
        </Route>
    </Routes>
);
export default VendorLedgerLayoutPage;
